import React from 'react';
import { mainPhotoLarge, mainPhotoLow } from '../../assets';
import './styles.scss';

const CoursesCoverImage = () => (
  <div className="courses-cover-image">
    <picture>
      <source media="(min-width: 575px)" srcSet={mainPhotoLarge} />
      <img src={mainPhotoLow} alt="Courses header" />
    </picture>
  </div>
);

export default CoursesCoverImage;
